<script>
  import solicitacaoCursoEventoMatricularServico from '../servico';
  import inscricaoServico from '~modulos/acessos/servico.js';
  import DadosInscricao from './compartilhado/FormDadosInscricao.vue';
  import DadosNotas from './compartilhado/FormInscricaoNotas.vue';
  import FormArquivos from './compartilhado/FormArquivos.vue';

  export default {
    components: { DadosInscricao, DadosNotas, FormArquivos },
    data() {
      return {
        inscricao: this.camposInscricao(),
        carregando: false,
        configuracao: this.$storage.configuracao(),
        arquivos: [],
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Inscrições Alunos - ${'Editar #' + this.$route.params.id}`;
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederRota = '';
      this.$root.botaoAcaoTexto = '';
      this.$root.botaoRetrocederMostrar = false;

      this.carregar(this.$route.params.idCript);
    },
    methods: {
      camposInscricao() {
        return {
          idInscricaoCript: '',
          idInscricao: '',
          documento: '',
          nome: '',
          endereco: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          uf: '',
          cep: '',
          telefone: '',
          celular: '',
          email: '',
          dataNascimento: '',
          identidade: '',
          tipo: 0,
          valor: 0,
          faixaValores: '',
          tipo: 1,
          questionarios: [],
          inscricaoNotas: [],
          solicitacaoCursoEventoServico: {
            turma: {
              cadastroCompleto: true,
            }
          }
        }
      },
      salvar() {
        $('#salvar').button('loading');

        this.enviar()
          .then(data => {
            $('#salvar').button('reset');

            this.carregar(data.id);
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a inscrição.');
          });
      },
      enviar() {
        const copiaInscricao = JSON.parse(JSON.stringify(this.inscricao));

        return solicitacaoCursoEventoMatricularServico.alterarNotas(copiaInscricao, this.inscricao.idInscricaoCript);
      },
      carregar(id) {
        this.carregando = true;

        let inscricao = null;

        solicitacaoCursoEventoMatricularServico
          .obterPorId(id)
          .then(dados => {
            inscricao = dados;
          })
          .then(() => inscricaoServico.arquivos(id, this.$route.params.utilizarArquivo))
          .then(arquivos => {

            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'inscricao', inscricao);
            this.carregando = false;
          });
      },
      download(arquivo) {
        inscricaoServico
          .download(this.$route.params.idCript, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form>

      <div class="row">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="!carregando">
        <div class="col-xs-12">
          <div class="tabs-container" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-inscricao">
                  Dados inscrição
                </a>
              </li>

              <li>
                <a data-toggle="tab"
                   href="#tab-dados-nota">
                  Dados notas
                </a>
              </li>

              <li v-if="$route.params.utilizarArquivo">
                <a data-toggle="tab"
                   href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-inscricao" class="tab-pane active">
                <div class="panel-body">
                  <dados-inscricao ref="dadosInscricao"
                                   :inscricao="inscricao">
                  </dados-inscricao>
                </div>
              </div>

              <div id="tab-dados-nota" class="tab-pane">
                <div class="panel-body">
                  <dados-notas ref="dadosNotas"
                               :inscricao="inscricao">
                  </dados-notas>
                </div>
              </div>

              <div id="tab-lista-arquivos" class="tab-pane" v-if="$route.params.utilizarArquivo">
                <div class="panel-body">
                  <form-arquivos :arquivos="arquivos"
                                 :inscricao="inscricao"
                                 @download="download"
                                 ref="listaArquivos">
                  </form-arquivos>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link class="btn btn-default"
                         :to="{ name: 'solicitacao-curso-evento-matricular', params: {filtrosBag: $route.params.filtrosBag} }"
                         active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button id="salvar"
                    type="button"
                    class="btn btn-primary"
                    v-if="!carregando"
                    @click="salvar"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-matricular/componentes/SolicitacaoCursoEventoMatricularForm.vue